import { routes } from 'core/constants/routes';
import { RootState } from 'core/store';
import { FaArrowCircleLeft, FaArrowCircleRight } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import DgCard from 'styles/UI/Card/DgCard';
import DgCardHeader from 'styles/UI/CardHeader/DgCardHeader';
import UserPlanCommissionsTable from 'components/UserPlanCommissions/List/components/UserPlanCommissionsTable';

const DashboardCommissions = () => {
	const { lang } = useSelector((store: RootState) => store.settingStore);
	const navigate = useNavigate();

	const ButtonPlanCommission =
		lang === 'en' ? (
			<FaArrowCircleRight
				onClick={() => navigate(routes.PLANS_COMMISSIONS())}
				style={{ cursor: 'pointer' }}
				size={24}
				color='var(--dg-primary-color)'
			/>
		) : (
			<FaArrowCircleLeft
				onClick={() => navigate(routes.PLANS_COMMISSIONS())}
				style={{ cursor: 'pointer' }}
				size={24}
				color='var(--dg-primary-color)'
			/>
		);

	return (
		<DgCard isMarginBottom={false} className='col-span-12'>
			<DgCardHeader title='my-profits' customButton={ButtonPlanCommission} />

			<UserPlanCommissionsTable limit={10} scroll={{ y: '300px', x: 'auto' }} />
		</DgCard>
	);
};

export default DashboardCommissions;
